import {
  getAllowedOrigins,
  isOriginAllowed,
} from '../global-auth-proxy/internal/cors';

function isRelativeUrl(url: string | null | undefined) {
  if (!url) {
    return false;
  }

  return url.startsWith('/') && !url.startsWith('//');
}

export function validateRedirectUrl(
  url: string | string[] | undefined | null,
  allowedOrigins?: string[]
): string | undefined {
  if (!url) {
    return undefined;
  }
  if (Array.isArray(url)) {
    url = url[0];
  }

  if (isRelativeUrl(url)) {
    return url;
  }

  const origins = allowedOrigins || getAllowedOrigins();

  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname.toLowerCase();

    if (isOriginAllowed(hostname, origins)) {
      return url;
    }
  } catch {
    return undefined;
  }

  return undefined;
}
